module.exports = __webpack_public_path__ + "static/4-e8b716f9b5a2b2ded66a4d68927ec7a3.jpg";